"use strict";
/**
 * Package jtd is an implementation of JSON Typedef.
 *
 * The {@link validate} function is an implementation of JSON Typedef
 * validation. The {@link Schema} interface represents JSON Typedef schemas.
 *
 * See [the README](https://github.com/jsontypedef/json-typedef-js) for examples
 * and links to guides on how to use this package.
 *
 * @packageDocumentation
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./schema"), exports);
__exportStar(require("./validate"), exports);
